<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// Segmented "Turno | Bloqueo" switch shown in the create dialogs' title row:
// empty cells always open the shift form, and this flips to the block form
// (and back) keeping the same patient/date prefill.
defineProps<{
  modelValue: 'shift' | 'block';
}>();

const emit = defineEmits<{
  'update:modelValue': [kind: 'shift' | 'block'],
}>();

const { t } = useI18n();
</script>
<template>
  <v-btn-toggle
    :model-value="modelValue"
    mandatory
    density="compact"
    variant="outlined"
    divided
    color="primary"
    data-testid="create-kind-toggle"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-btn
      value="shift"
      size="small"
      prepend-icon="mdi-calendar-plus"
      data-testid="create-kind-shift"
    >
      {{ t('scheduleBlocks.kindToggle.shift') }}
    </v-btn>
    <v-btn
      value="block"
      size="small"
      prepend-icon="mdi-calendar-lock"
      data-testid="create-kind-block"
    >
      {{ t('scheduleBlocks.kindToggle.block') }}
    </v-btn>
  </v-btn-toggle>
</template>
